function animateAutomationPathways() {
  // List of required element IDs
  const requiredIds = [
    "#lSpecial",
    "#l3",
    "#l9",
    "#l7",
    "#rSpecial",
    "#rBottom",
    "#rRight",
    "#rLeft",
  ];

  // Check if all required elements exist
  const allElementsExist = requiredIds.every((id) =>
    document.querySelector(id)
  );

  if (!allElementsExist) {
    // Do nothing if any of the required elements are missing
    return;
  }

  // Proceed with animations only if all elements are present
  let lSpecial = gsap.timeline();
  lSpecial.to("#lSpecial", { rotate: 360, duration: 4 });

  let tlLeft = gsap
    .timeline({ repeat: -1 })
    .to("#l3", { borderColor: "white", duration: 0.5 })
    .to("#l3", { borderColor: "black", duration: 0.5, delay: 0.5 })

    .to("#l9", { borderColor: "white", duration: 0.5 })
    .to("#l9", { borderColor: "black", duration: 0.5, delay: 0.5 })

    .to("#l7", { borderColor: "white", duration: 0.5 })
    .to("#l7", { borderColor: "black", duration: 0.5, delay: 0.5 });

  let tlRight = gsap.timeline({ repeat: -1 });
  tlRight
    .to("#rSpecial", { rotate: 360, duration: 3 })
    .to("#rSpecial", { y: -60, duration: 0.8 }, 3)
    .to("#rBottom", { y: 60, duration: 0.8, opacity: 1 }, 3)
    .to("#rRight", { x: 60, duration: 0.8, opacity: 1 }, 3)
    .to("#rLeft", { x: -60, duration: 0.8, opacity: 1 }, 3)

    // join
    .to("#rSpecial", { y: 0, duration: 1 }, 7)
    .to("#rBottom", { y: 0, duration: 0.8, opacity: 0 }, 7)
    .to("#rRight", { x: 0, duration: 0.8, opacity: 0 }, 7)
    .to("#rLeft", { x: 0, duration: 0.8, opacity: 0 }, 7);
}

animateAutomationPathways();
